import { withStyles } from '@material-ui/core';
import TimeString from './TimeString';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import StyledToolTip from '../../../../../common/StyledToolTip';

const styles = (theme) => ({
  container: {
    margin: '10 0'
  },
  withBorderContainer: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 8,
    padding: 8,
    margin: '0 6',
    height: 68
  },
  kpiHeader: {
    color: theme.TextColor,
    textAlign: 'center',
    fontSize: 22,
    lineHeight: '30px',
    fontWeight: 600,
    justifyContent: 'center'
  },
  kpiLabel: {
    color: theme.TextColor,
    textAlign: 'center',
    fontSize: 14,
    fontWeight: 400,
    display: 'flex',
    justifyContent: 'center'
  },
  kpiIcon: {
    padding: '2px',
    color: theme.HeaderSelectedText
  }
});

const KpiInfo = ({ value, name, classes, withBorder, isTimeString, showPlannedIcon }) => {
  return (
    <div className={withBorder ? classes.withBorderContainer : classes.container}>
      {isTimeString && value? (
        <TimeString minutes={value} />
      ) : (
        <div className={classes.kpiHeader}>{value}</div>
      )}
      <div className={classes.kpiLabel}>
        {name}
        {showPlannedIcon && (
          <StyledToolTip title={'RouteMax estimate'}>
            <InfoOutlinedIcon className={classes.kpiIcon} />
          </StyledToolTip>
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(KpiInfo);
